// import ErrorResponse from '../models/ErrorResponse';
import BaseApi from './BaseApi';
import ResetExpiredPassword from 'src/models/ResetExpiredPassword';

export interface IAuth {
    login(username: string, password: string): Promise<object>;
    setNewPassword(password: string, jwt: string): Promise<object>;
    forgotPassword(email: string): Promise<object>;
    forgotPasswordReset(payload: { password: string; resetKey: string }): Promise<object>;
    enableTwoFactor(jwt: string): Promise<object>;
    confirmTwoFactor(twoFactorAuthPin: string, jwt: string): Promise<object>;
    disableTwoFactor(jwt: string): Promise<object>;
    loginTwoFactor(twoFactorAuthPin: string, jwt: string): Promise<object>;
    resetExpiredPassword(resetExpiredPassword: ResetExpiredPassword): Promise<object>;
}

export default class Auth extends BaseApi implements IAuth {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    public login = (username: string, password: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/auth/login`, { username, password });
    };

    loginTwoFactor = (twoFactorAuthPin: string, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/authtwofactor/two-factor-login`, { twoFactorAuthPin }, jwt);
    };

    setNewPassword = (password: string, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/auth/change-password`, { password }, jwt);
    };

    forgotPassword = (username: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/auth/reset-password`, { username });
    };

    forgotPasswordReset = (payload: { password: string; resetKey: string }) => {
        return this.postRequest(`${this.baseUrl}v1.0/auth/reset-password/token`, payload);
    };

    enableTwoFactor = (jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/authtwofactor/two-factor-enable`, undefined, jwt);
    };

    confirmTwoFactor = (twoFactorAuthPin: string, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/authtwofactor/two-factor-confirm`, { twoFactorAuthPin }, jwt);
    };

    disableTwoFactor = (jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/authtwofactor/two-factor-disable`, undefined, jwt);
    };

    resetExpiredPassword = (resetExpiredPassword: ResetExpiredPassword) => {
        return this.postRequest(`${this.baseUrl}v1.0/auth/reset-password/expired`, resetExpiredPassword);
    };
}



// WEBPACK FOOTER //
// ./src/api/Auth.ts